<template>
  <AccountPatient :patientId="patientId"></AccountPatient>
</template>
<script>
import AccountPatient from "../../../../components/account/Patient";
import { xray } from "../../../../config/pluginInit";

import utilsService from "../../../../services/utils";

export default {
  name: "Account",
  mounted() {
    xray.index();
    utilsService.auditActivity({ action: "VIEW", module: "PATIENT_MY_ACCOUNT", info: "" });
  },
  components: { AccountPatient },
  data() {
    return {
      patientId: localStorage.getItem("userId"),
    };
  },
  methods: {},
  computed: {},
};
</script>
